import { render } from "./CallDetailReport.vue?vue&type=template&id=4bf7768b&scoped=true"
import script from "./CallDetailReport.vue?vue&type=script&lang=js"
export * from "./CallDetailReport.vue?vue&type=script&lang=js"

import "./CallDetailReport.vue?vue&type=style&index=0&id=4bf7768b&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf7768b"]])

export default __exports__